// ======================================================================
// File Name       : EnterpriseNoticeConstants
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const USE_DATE_RELEASE = {
  INDEFINITE_PERIOD: 0,
  RELEASE_DATE: 1,
};

export const PUBLIC_STATUS = [
  { name: '非公開', value: 0 },
  { name: '公開', value: 1 },
];

export const RELEASE_TARGET_NOTICE_FOR_ENTERPRISE = [
  { name: '企業内', value: 0 },
  { name: '従属企業全体', value: 1 },
];
